import { render, staticRenderFns } from "./TelegramEntegration.vue?vue&type=template&id=43e347e2"
import script from "./TelegramEntegration.vue?vue&type=script&lang=js"
export * from "./TelegramEntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports